import { editorLocalization } from "../editorLocalization";

var portugueseTranslation = {
  //survey templates
  survey: {
    edit: "Editar",
    externalHelpLink: "Assista o vídeo e aprenda a criar questionários",
    externalHelpLinkUrl:
      "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
    dropQuestion: "Por favor arraste uma pergunta para aqui.",
    addLogicItem: "Crie uma regra para personalizar o fluxo do questionário.",
    copy: "Copiar",
    duplicate: "Duplicar",
    addToToolbox: "Adicionar à barra de ferramentas",
    deletePanel: "Remover Painel",
    deleteQuestion: "Remover Pergunta",
    convertTo: "Converter para",
    drag: "Arrastar elemento"
  },
  //questionTypes
  qt: {
    default: "Default",
    checkbox: "Checkbox",
    comment: "Comentário",
    imagepicker: "Seletor de imagem",
    ranking: "Ranking",
    image: "Imagem",
    dropdown: "Dropdown",
    file: "Arquivo",
    html: "Html",
    matrix: "Matriz (opção única)",
    matrixdropdown: "Matriz (múltiplas opções)",
    matrixdynamic: "Matriz (linhas dinâmicas)",
    multipletext: "Texto múltiplo",
    panel: "Painel",
    paneldynamic: "Painel (painéis dinâmicos)",
    radiogroup: "Radiogroup",
    rating: "Rating",
    text: "Texto único",
    boolean: "Booleano",
    expression: "Expressão (somente leitura)",
    signaturepad: "Campo de assinatura",
    flowpanel: "Painel de Fluxo",
  },
  //Strings in Editor
  ed: {
    defaultLocale: "Default ({0})",
    survey: "Questionário",
    settings: "Configurações do questionário",
    settingsTooltip: "Mostrar configurações do questionário",
    //opjectPropertiesHeader: "Avançado",
    //showObjectProperties: "Mostrar Propriedades do Objeto",
    //hideObjectProperties: "Ocultar Propriedades do Objeto",
    showPanel: "Mostrar Painel",
    hidePanel: "Ocultar Painel",
    //editSurvey: "Editar Questionário",
    addNewPage: "Adicionar Nova Página",
    moveRight: "Mover para direita",
    moveLeft: "Mover para esquerda",
    deletePage: "Apagar Página",
    editPage: "Editar Página",
    edit: "Editar",
    newPageName: "página",
    newQuestionName: "pergunta",
    newPanelName: "painel",
    newTextItemName: "texto",
    testSurvey: "Testar questionário",
    testSurveyAgain: "Testar questionário novamente",
    testSurveyWidth: "Tamanho do questionário: ",
    navigateToMsg: "Você teve que navegar para:",
    logic: "Lógica do Questionário",
    embedSurvey: "Incorporar Questionário",
    translation: "Tradução",
    saveSurvey: "Guardar Questionário",
    saveSurveyTooltip: "Guardar Questionário",
    designer: "Designer de Questionário",
    jsonEditor: "Editor de JSON",
    undo: "Desfazer",
    redo: "Refazer",
    undoTooltip: "Desfazer última modificação",
    redoTooltip: "Refazer modificação",
    copy: "Copiar",
    cut: "Recortar",
    paste: "Colar",
    copyTooltip: "Copiar seleção para a área de transferência",
    cutTooltip: "Recortar seleção para a área de transferência",
    pasteTooltip: "Colar da área de transferência",
    options: "Opções",
    generateValidJSON: "Gerar JSON válido",
    generateReadableJSON: "Gerar JSON legível",
    toolbox: "Ferramentas",
    "property-grid": "Propriedades",
    toolboxGeneralCategory: "Geral",
    //delSelObject: "Apagar objeto selecionado",
    //editSelObject: "Editar objeto selecionado",
    correctJSON: "Por favor corrija o JSON.",
    surveyResults: "Resultado do questionário: ",
    surveyResultsTable: "Como Tabela",
    surveyResultsJson: "Como JSON",
    resultsTitle: "Título da Pergunta",
    resultsName: "Nome da Pergunta",
    resultsValue: "Valor da Resposta",
    resultsDisplayValue: "Mostrar Valor",
    modified: "Modificado",
    saving: "A guardar",
    saved: "Guardado",
    propertyEditorError: "Erro:",
    saveError: "Erro! Conteúdo do editor não foi guardado.",
    translationAddLanguage: "Selecione o idioma para traduzir",
    translationShowAllStrings: "Mostrar todas strings",
    translationShowAllPages: "Mostrar todas páginas",
    translationNoStrings: "Nenhuma string para traduzir. Por favor, altere o filtro.",
    translationExportToSCVButton: "Exportar para CSV",
    translationImportFromSCVButton: "Importar de CSV",
    translationMergeLocaleWithDefault: "Combinar {0} com o idioma default",
    bold: "Negrito",
    italic: "Itálico",
    underline: "Sublinhado",
    fpAddQuestion: "Adicionar pergunta...",
    selectPage: "Selecionar página...",
    chooseElement: "Escolha um elemento...",
    //completedHtmlOnConditionItemText: "Exibir se:",
    lg: {
      addNewItem: "", //By default the value is taken from pe.addNew 'Add New', you can set it to 'Add New Rule' for example.
      //Logic tab strings
      page_visibilityName: "Visibilidade da Página",
      panel_visibilityName: "Visibilidade do Painel",
      panel_enableName: "Ativar/desativar painel",
      question_visibilityName: "Visibilidade da pergunta",
      question_enableName: "Habilitar/desabilitar pergunta",
      question_requireName: "Questão opcional obrigatória",
      trigger_completeName: "Completar Questionário",
      trigger_setvalueName: "Defina o valor da pergunta",
      trigger_copyvalueName: "Copiar o valor da pergunta",
      trigger_skipName: "Saltar para a pergunta",
      trigger_runExpressionName: "Executar expressão personalizada",
      completedHtmlOnConditionName: "Nome da página de conclusão personalizada",

      page_visibilityDescription:
        "Torne a página visível quando a expressão lógica retornar verdadeiro. Caso contrário, mantenha-a invisível.",
      panel_visibilityDescription:
        "Torne o painel visível quando a expressão lógica retornar verdadeiro. Caso contrário, mantenha-o invisível.",
      panel_enableDescription:
        "Faça com que o painel, e todos os elementos dentro dele, sejam habilitados quando a expressão lógica retornar verdadeiro. Caso contrário, mantenha-os desabilitados.",
      question_visibilityDescription:
        "Torne a pergunta visível quando a expressão lógica retornar verdadeiro. Caso contrário, mantenha-a invisível.",
      question_enableDescription:
        "Ative a pergunta quando a expressão lógica retornar verdadeiro. Caso contrário, mantenha-a desativada.",
      question_requireDescription:
        "A pergunta torna-se necessária quando a expressão lógica retorna verdadeiro.",
      trigger_completeDescription:
        "Quando a expressão lógica retorna verdadeiro, o questionário é concluído e o utilizador vê a 'página de agradecimento'.",
      trigger_setvalueDescription:
        "Quando os valores da pergunta, que são usados ​​na expressão lógica, são alterados e a expressão lógica retorna verdadeiro, o valor é definido para a pergunta selecionada.",
      trigger_copyvalueDescription:
        "Quando os valores da pergunta, que são usados ​​na expressão lógica, são alterados e a expressão lógica retorna verdadeiro, o valor de uma pergunta selecionada é copiado para outra pergunta selecionada.",
      trigger_skipDescription:
        "Quando a expressão lógica retorna verdadeiro, o questionário salta para / foca a questão selecionada.",
      trigger_runExpressionDescription:
        "Quando a expressão lógica retorna verdadeiro, a expressão personalizada é executada. Você pode, opcionalmente, definir o resultado desta expressão na pergunta selecionada",
      completedHtmlOnConditionDescription:
        "Se a expressão lógica retornar verdadeiro, o texto padrão da 'página de agradecimento' será alterado para o fornecido.",

      itemExpressionText: "Quando a expressão: '{0}' retorna verdadeiro:", // {0} - a expressão
      page_visibilityText: "Tornar a página {0} visível", // {0} nome da página
      panel_visibilityText: "Tornar o painel {0} visível", // {0} nome do painel
      panel_enableText: "Tornar painel {0} habilitar", // {0} nome do painel
      question_visibilityText: "Tornar a pergunta {0} visível", // {0} nome da pergunta
      question_enableText: "Faça a pergunta {0} ativada", // {0} nome da pergunta
      question_requireText: "Tornar a pergunta {0} obrigatória", // {0} nome da pergunta
      trigger_completeText: "O questionário foi concluído",
      trigger_setvalueText: "Colocar em questão: {0} valor {1}", // {0} nome da questão, {1} setValue
      trigger_copyvalueText: "Copiar para a questão: {0} valor da questão {1}", // {0} e {1} nomes das questões
      trigger_skipText: "Questionário salta para a questão {0}", // {0} nome da questão
      trigger_runExpressionText1: "Executar expressão: '{0}'", // {0} a expressão
      trigger_runExpressionText2: "e coloque o seu resultado em questão: {0}", // {0} nome da questão
      completedHtmlOnConditionText:
        "Mostrar texto personalizado para a 'página de agradecimento'.",

      conditions: "Condição(ões)",
      actions: "Ação(ões)",
      expressionEditorTitle: "Definir condição(ões)",
      actionsEditorTitle: "Definir ação(ões)",

      deleteAction: "Excluir ação",
      addNewAction: "Adicionar nova ação",
      selectedActionCaption: "Selecione uma ação para adicionar ...",

      expressionInvalid:
        "A expressão lógica está vazia ou é inválida. Corrija-a.",
      noActionError: "Por favor, adicione pelo menos uma ação.",
      actionInvalid: "Por favor, corrija problemas em suas ações.",
      expressionSetup: "",
      actionsSetup: "",
    },
  },
  //Property names in table headers
  // pel: {
  //  isRequired: "Obrigatório?"
  // },
  //Property Editors
  pe: {
    apply: "Aplicar",
    ok: "OK",
    save: "Guardar",
    saveTooltip: "Guardar",
    cancel: "Cancelar",
    reset: "Limpar",
    refresh: "Atualizar",
    // close: "Fechar",
    delete: "Apagar",
    add: "Adicionar",
    addNew: "Adicionar Novo",
    addItem: "Clique para adicionar um item...",
    addOther: "Outro",
    addSelectAll: "Selecionar Tudo",
    addNone: "Nenhum",
    removeAll: "Remover Todos",
    edit: "Editar",
    back: "Voltar sem guardar",
    backTooltip: "Voltar sem guardar",
    saveAndBack: "Guardar e voltar",
    saveAndBackTooltip: "Guardar e voltar",
    // itemValueEdit: "Visível Se",
    editChoices: "Editar Opções",
    showChoices: "Mostrar Opções",
    move: "Mover",
    empty: "<vazio>",
    // notEmpty: "<editar valor>",
    fastEntry: "Entrada Rápida",
    formEntry: "Entrada com formulário",
    testService: "Testar o serviço",
    itemSelectorEmpty: "Por favor selecione o elemento",
    conditionActionEmpty: "Por favor selecione a ação",
    conditionSelectQuestion: "Selecionar pergunta...",
    conditionSelectPage: "Selecionar página ...",
    conditionSelectPanel: "Selecionar painel ...",
    conditionValueQuestionTitle: "Por favor, insira/selecione o valor",
    // conditionHelp:
    //  "Por favor, entre com uma expressão boleana. Deve retornar verdadeiro para manter a pergunta/página visível. Por exemplo: {´pergunta1} = 'valor1' ou ({pergunta2} * {pergunta4} > 20 e {pergunta3} < 5)",
    expressionHelp:
      "Por favor insira uma expressão booleana. Ela deve retornar verdadeiro para manter a pergunta/página visível. Por exemplo: {´pergunta1} = 'valor1' or ({pergunta2} = 3 and {pergunta3} < 5)",
    aceEditorHelp: "Pressione ctrl+espaço para autocompletar",
    aceEditorRowTitle: "Linha atual",
    aceEditorPanelTitle: "Painel atual",
    showMore: "Para mais detalhes, por favor visite a documentação",
    // conditionShowMoreUrl:
    //  "https://surveyjs.io/Documentation/LibraryParameter?id=Question&parameter=visibleIf",
    assistantTitle: "Perguntas disponíveis:",
    cellsEmptyRowsColumns: "Deve existir pelo menos uma coluna ou linha",

    propertyIsEmpty: "Por favor insira um valor na propriedade",
    propertyIsNoUnique: "Por favor insira um valor único",
    propertyNameIsNotUnique: "Por favor insira um nome único",
    listIsEmpty: "Adicionar um novo item",
    expressionIsEmpty: "A Expressão está vazia",
    value: "Valor",
    text: "Texto",
    rowid: "ID da Linha",
    imageLink: "Link da Imagem",
    columnEdit: "Editar coluna: {0}",
    itemEdit: "Editar item: {0}",

    url: "URL",
    path: "Caminho",
    valueName: "Nome do valor",
    titleName: "Nome do título",
    titlePlaceholder: "Insira o título aqui",
    surveyTitlePlaceholder: "Insira o título do questionário aqui",
    pageTitlePlaceholder: "Insira o título da página aqui",
    descriptionPlaceholder: "Insira a descrição",
    surveyDescriptionPlaceholder: "Insira a descrição do questionário",
    pageDescriptionPlaceholder: "Insira a descrição da página",

    hasOther: "Tem item 'outros'",
    otherText: "Texto do item 'outros'",
    hasNone: "Tem item 'nenhum'",
    noneText: "Texto do item 'nenhum'",
    hasSelectAll: "Tem item 'selecionar todos'",
    selectAllText: "Texto do item 'selecionar todos'",
    choicesMin: "Valor mínimo para itens gerados automaticamente",
    choicesMax: "Valor máximo para itens gerados automaticamente",
    choicesStep: "A diferença entre itens gerados automaticamente",
    name: "Nome",
    title: "Título",
    cellType: "Tipo de célula",
    colCount: "Contagem de células",
    choicesOrder: "Selecione a ordem das alternativas",
    visible: "É visível?",
    isRequired: "É obrigatório?",
    isAllRowRequired: "Obrigatório resposta para todas as linhas",
    requiredErrorText: "Texto do erro de obrigatoriedade",
    startWithNewLine: "Começa com uma nova linha?",
    rows: "Contagem de linhas",
    cols: "Contagem de colunas",
    placeHolder: "Placeholder",
    showPreview: "Mostra pré-visualização de imagem?",
    storeDataAsText: "Gravar conteúdo de arquivo no resultado JSON como texto",
    maxSize: "Tamanho máximo de arquivo em bytes",
    imageHeight: "Altura da imagem",
    imageWidth: "Largura da imagem",
    rowCount: "Contagem de linhas",
    columnLayout: "Layout das colunas",
    addRowLocation: "Localização do botão de adicionar linha",
    addRowText: "Texto do botão para adicionar linhas",
    removeRowText: "Texto do botão para remover linhas",
    rateMin: "Avaliação mínima",
    rateMax: "Avaliação máxima",
    rateStep: "Incremento da avaliação",
    minRateDescription: "Descrição de avaliação mínima",
    maxRateDescription: "Descrição de avaliação máxima",
    inputType: "Tipo de campo",
    optionsCaption: "Título das opções",
    defaultValue: "Valor default",
    cellsDefaultRow: "Texto default das células",

    surveyEditorTitle: "Editar configurações do questionário",
    qEditorTitle: "Editar pergunta: {0}",

    maxLength: "Tamanho máximo",

    buildExpression: "Construir",
    editExpression: "Editar",
    and: "E",
    or: "Ou",
    remove: "Remover",
    addCondition: "Adicionar condição",

    //survey
    showTitle: "Mostrar/ocultar título",
    expandCollapseTitle: "Expandir/colapsar título",
    locale: "Idioma padrão",
    simulator: "Escolha o dispositivo",
    landscapeOrientation: "Paisagem",
    mode: "Modo (editável/somente leitura)",
    clearInvisibleValues: "Limpar valores invisíveis",
    cookieName: "Nome do cookie (para desativar corra o questionário duas vezes localmente)",
    sendResultOnPageNext: "Enviar resultado do questionário na página seguinte",
    storeOthersAsComment: "Armazenar 'outros' valores em um campo separado",
    showPageTitles: "Mostrar título da página",
    showPageNumbers: "Mostrar número da página",
    pagePrevText: "Texto para botão de página anterior",
    pageNextText: "Texto para botão de página seguinte",
    completeText: "Texto para botão de completar",
    previewText: "Texto do botão de Pré-visualização'",
    editText: "Texto do botão 'Editar'",
    startSurveyText: "Texto para botão de começar",
    showNavigationButtons: "Mostrar botões de navegação (navegação padrão)",
    showPrevButton: "Mostrar botão de voltar (utilizador pode voltar para a página anterior)",
    firstPageIsStarted: "Primeira página do questionário é a página de início.",
    showCompletedPage: "Mostrar a página de conclusão no final (completedHtml)",
    goNextPageAutomatic:
      "Ao responder a todas as perguntas, ir automaticamente para a próxima página",
    showProgressBar: "Mostrar barra de progresso",
    questionTitleLocation: "Localização do título da pergunta",
    requiredText: "Símbolo(s) para perguntas obrigatórias",
    questionStartIndex: "Index das perguntas (1, 2 or 'A', 'a')",
    showQuestionNumbers: "Mostrar número das perguntas",
    questionTitleTemplate:
      "Template do título da pergunta, o padrão é: '{no}. {obrigatório} {título}'",
    questionErrorLocation: "Localização do erro da pergunta",
    focusFirstQuestionAutomatic: "Focar automaticamente na primeira pergunta ao trocar de página",
    questionsOrder: "Ordenar elementos na página",
    maxTimeToFinish: "Tempo máximo para finalizar o questionário",
    maxTimeToFinishPage: "Tempo máximo para finalizar página do questionário",
    showTimerPanel: "Mostrar o painel de cronómetro",
    showTimerPanelMode: "Mostrar painel de modo de cronómetro",
    renderMode: "Modo de renderização",
    allowAddPanel: "Permitir adicionar painel",
    allowRemovePanel: "Permitir remover painel",
    panelAddText: "Texto de adicionar painel",
    panelRemoveText: "Texto de remover painel",
    isSinglePage: "Mostrar todos elementos em uma página",
    html: "Html",
    expression: "Expressão",

    minValue: "Valor mínimo",
    maxValue: "Valor máximo",
    minLength: "Tamanho mínimo",
    allowDigits: "Permitir dígitos",
    minCount: "Contagem mínima",
    maxCount: "Contagem máxima",
    regex: "Expressão regular",

    totalText: "Texto do total",
    totalType: "Tipo do total",
    totalExpression: "Expressão do total",
    totalDisplayStyle: "Estilo de exibição do total",
    totalCurrency: "Moeda do total",
    totalFormat: "Formato do total",

    // Header  adorner
    logoPosition: "Posição do logotipo",
    addLogo: "Adicionar logotipo...",
    changeLogo: "Alterar logotipo...",
    logoPositions: {
      none: "Remover logotipo",
      left: "Esquerda",
      right: "Direita",
      top: "No topo",
      bottom: "No rodapé",
    },

    tabs: {
      general: "Geral",
      fileOptions: "Opções",
      html: "Editor Html",
      columns: "Colunas",
      rows: "Linhas",
      choices: "Opções",
      items: "Itens",
      visibleIf: "Visível se",
      enableIf: "Habilitar se",
      requiredIf: "Obrigatório se",
      rateValues: "Valores de Avaliação",
      choicesByUrl: "Opções com origem na Web",
      matrixChoices: "Opções padrão",
      multipleTextItems: "Entradas de texto",
      numbering: "Numeração",
      validators: "Validadores",
      navigation: "Navegação",
      question: "Pergunta",
      pages: "Páginas",
      completedHtml: "Html de conclusão do questionário",
      completedHtmlOnCondition: "Html condicional de conclusão do questionário",
      loadingHtml: "Html de carregamento do questionário",
      timer: "Cronómetro/Quiz",
      calculatedValues: "Valores Calculados",
      triggers: "Gatilhos",
      templateTitle: "Título do template",
      totals: "Totais",
      logic: "Lógica",
      layout: "Layout",
      data: "Dados",
      validation: "Validação",
      cells: "Células",
      showOnCompleted: "Mostrar na conclusão",
      logo: "Logo no Título do Questionário",
      slider: "Slider",
      others: "Outros",
    },
    editProperty: "Editar propriedade '{0}'",
    items: "[ Itens: {0} ]",

    enterNewValue: "Por favor, insira o valor.",
    noquestions: "Não há nenhuma pergunta no questionário.",
    createtrigger: "Por favor, crie um gatilho",
    titleKeyboardAdornerTip: "Pressione Enter para editar",
    keyboardAdornerTip:
      "Pressione o botão Enter para editar o item, pressione o botão Excluir para excluir o item, pressione Alt mais a seta para cima ou a seta para baixo para mover o item",
    triggerOn: "Ligado ",
    triggerMakePagesVisible: "Tornar páginas visíveis:",
    triggerMakeQuestionsVisible: "Tornar perguntas visíveis:",
    triggerCompleteText: "Completar o questionário se obtiver êxito.",
    triggerNotSet: "O gatilho não está definido",
    triggerRunIf: "Executar se",
    triggerSetToName: "Mudar o valor de: ",
    triggerFromName: "Copiar valor de: ",
    triggerRunExpression: "Executar esta expressão:",
    triggerSetValue: "para: ",
    triggerGotoName: "Ir para a questão:",
    triggerIsVariable: "Não coloque a variável no resultado do questionário.",
    triggerRunExpressionEmpty: "Por favor insira uma expressão válida",

    noFile: "Nenhum arquivo selecionado",
  },
  //Property values
  pv: {
    true: "verdadeiro",
    false: "falso",
    inherit: "herdar",
    show: "mostrar",
    hide: "ocultar",
    default: "padrão",
    initial: "inicial",
    random: "aleatório",
    collapsed: "colapsado",
    expanded: "expandido",
    none: "nenhum",
    asc: "ascendente",
    desc: "descendente",
    indeterminate: "indeterminado",
    decimal: "decimal",
    currency: "moeda",
    percent: "percentagem",
    firstExpanded: "primeiro expandido",
    off: "desligado",
    onPanel: "no painel",
    onSurvey: "no questionário",
    list: "lista",
    progressTop: "progresso superior",
    progressBottom: "progresso inferior",
    progressTopBottom: "progresso superior inferior",
    horizontal: "horizontal",
    vertical: "vertical",
    top: "superior",
    bottom: "inferior",
    topBottom: "superior e inferior",
    both: "ambos",
    left: "esquerda",
    color: "cor",
    date: "data",
    datetime: "data e hora",
    "datetime-local": "data e hora - local",
    email: "email",
    month: "mês",
    number: "número",
    password: "senha",
    range: "intervalo",
    tel: "tel",
    text: "texto",
    time: "hora",
    url: "url",
    week: "semana",
    hidden: "oculto",
    on: "ligado",
    onPage: "na página",
    edit: "editar",
    display: "mostrar",
    onComplete: "ao completar",
    onHidden: "ao ocultar",
    all: "todos",
    page: "página",
    survey: "questionário",
    onNextPage: "na página seguinte",
    onValueChanged: "ao mudar valor",
    singlePage: "página única",
    standard: "padrão",
    questionPerPage: "questões por página",
    noPreview: "sem pré-visualização",
    showAllQuestions: "mostrar pré-visualização com todas as questões",
    showAnsweredQuestions: "mostrar pré-visualização com as questões respondidas",
  },
  //Operators
  op: {
    empty: "está vazio",
    notempty: "não está vazio",
    equal: "é igual",
    notequal: "não é igual",
    contains: "contém",
    notcontains: "não contém",
    anyof: "qualquer um de",
    allof: "todos de",
    greater: "maior",
    less: "menor",
    greaterorequal: "maior ou igual",
    lessorequal: "menor ou igual",
    and: "e",
    or: "ou",
  },
  //Embed window
  ew: {
    angular: "Usar versão Angular",
    jquery: "Usar versão jQuery",
    knockout: "Usar versão Knockout",
    react: "Usar versão React",
    vue: "Usar versão Vue",
    bootstrap: "Para framework bootstrap",
    modern: "Tema Modern",
    default: "Tema Padrão",
    orange: "Tema Orange",
    darkblue: "Tema Darkblue",
    darkrose: "Tema Darkrose",
    stone: "Tema Stone",
    winter: "Tema Winter",
    winterstone: "Tema Winterstone",
    showOnPage: "Mostrar questionário numa página",
    showInWindow: "Mostrar questionário numa janela",
    loadFromServer: "Carregar JSON do questionário de um servidor",
    titleScript: "Scripts e estilos",
    titleHtml: "HTML",
    titleJavaScript: "JavaScript"
  },
  //Test Survey
  ts: {
    selectPage: "Selecione a página para testar:",
    showInvisibleElements: "Mostrar elementos invisíveis"
  },
  validators: {
    answercountvalidator: "contador de respostas",
    emailvalidator: "e-mail",
    expressionvalidator: "expressão",
    numericvalidator: "numérico",
    regexvalidator: "regex",
    textvalidator: "texto"
  },
  triggers: {
    completetrigger: "completar questionário",
    setvaluetrigger: "definir valor",
    copyvaluetrigger: "copiar valor",
    skiptrigger: "pular para questão",
    runexpressiontrigger: "rodar expressão",
    visibletrigger: "alterar visibilidade"
  },
  pehelp: {
    //expression:
  },
  //Properties
  p: {
    name: "nome",
    title: {
      name: "título",
      title: "Deixar vazio se for o mesmo que 'Nome'"
    },

    navigationButtonsVisibility: "Visibilidade dos botões de navegação",
    questionsOrder: "Ordenar elementos na página",
    maxTimeToFinish: "Tempo máximo para finalizar questionário",

    visible: "Visível?",
    visibleIf: "Visível se",
    questionTitleLocation: "Localização do título da pergunta",
    description: "Descrição",
    state: "Estado",
    isRequired: "Obrigatório?",
    requiredIf: "Obrigatório se",
    indent: "Indentação",
    requiredErrorText: "Texto de erro para obrigatório",
    startWithNewLine: "Começar com uma nova linha",
    innerIndent: "Indentação interna",
    page: "Página",

    width: "Largura",

    commentText: "Texto do comentário",
    valueName: "Nome do valor",
    enableIf: "Habilitar se",
    defaultValue: "Valor default",
    correctAnswer: "Resposta correta",
    readOnly: "Somente leitura",
    validators: "Validadores",
    titleLocation: "Localização do título",

    hasComment: "Tem comentário",
    hasOther: "Tem item 'outros'",
    choices: "Opções",
    choicesOrder: "Selecione a ordem das opções",
    choicesByUrl: "Opções com origem na Web",
    otherText: "Texto do item 'outros'",
    otherErrorText: "Texto de erro da opção 'outros'",
    storeOthersAsComment: "Armazenar 'outros' valores em um campo separado",

    label: "Label",
    showTitle: "Mostrar título",
    valueTrue: "Valor verdadeiro",
    valueFalse: "Valor falso",

    cols: "Colunas",
    rows: "Linhas",
    placeHolder: "placeholder",

    optionsCaption: "Título das opções",

    expression: "Expressão",
    format: "Formato",
    displayStyle: "Mostrar estilo",
    currency: "Moeda",
    useGrouping: "Usar agrupamento",

    showPreview: "Mostrar pré-visualização",
    allowMultiple: "Permitir múltiplos",
    imageHeight: "Altura da imagem",
    imageWidth: "Largura da imagem",
    storeDataAsText: "Armazenar dados como texto",
    maxSize: "Tamanho máximo",

    html: "html",

    columns: "Colunas",
    cells: "Células",
    isAllRowRequired: "Todas as linhas são obrigatórias",

    horizontalScroll: "Scroll horizontal",
    cellType: "Tipo de célula",
    columnsLayout: "Layout de colunas",
    columnColCount: "Contador de células de coluna",
    columnMinWidth: "Largura mínima da coluna",

    rowCount: "Contagem de linhas",
    minRowCount: "Contagem de linhas mínima",
    maxRowCount: "Contagem de linhas máxima",
    keyName: "Nome da chave",
    keyDuplicationError: "Erro de chave duplicada",
    confirmDelete: "Confirmar apagar",
    confirmDeleteText: "Texto de confirmar apagar",
    addRowLocation: "Localização do botão de adicionar linha",
    addRowText: "Texto do botão para adicionar linhas",
    removeRowText: "Texto do botão para remover linhas",

    items: "Itens",
    itemSize: "Tamanho do item",
    colCount: "Contagem de células",

    templateTitle: "Título do template",
    templateDescription: "Descrição do template",
    allowAddPanel: "Permitir adicionar painel",
    allowRemovePanel: "Permitir remover painel",
    panelCount: "Contador do painel",
    minPanelCount: "Contador do painel mínimo",
    maxPanelCount: "Contador do painel máximo",
    panelsState: "Estado dos painéis",
    panelAddText: "Texto de adicionar painel",
    panelRemoveText: "Texto de remover painel",
    panelPrevText: "Texto do painel anterior",
    panelNextText: "Texto do próximo painel",
    showQuestionNumbers: "Mostrar número das perguntas",
    showRangeInProgress: "showRangeInProgress",
    renderMode: "Modo de renderização",
    templateTitleLocation: "Localização do título do template",

    rateValues: "Valores de avaliação",
    rateMin: "Avaliação mínima",
    rateMax: "Avaliação máxima",
    rateStep: "Incremento da avaliação",
    minRateDescription: "Descrição de avaliação mínima",
    maxRateDescription: "Descrição de avaliação máxima",

    inputType: "Tipo de campo",
    size: "Tamanho",

    locale: "Localidade",
    focusFirstQuestionAutomatic: "Focar automaticamente na primeira pergunta",
    completedHtml: "Html ao completar",
    completedBeforeHtml: "Html antes de completar",
    loadingHtml: "Html 'a carregar'",
    triggers: "Triggers",
    cookieName: "Nome do cookie",
    sendResultOnPageNext: "Enviar resultado do questionário na página seguinte",
    showNavigationButtons: "Mostrar botões de navegação (navegação default)",
    showPrevButton: "Mostrar botão de voltar (utilizador pode voltar à página anterior)",
    showPageTitles: "Mostrar título da página",
    showCompletedPage: "Mostrar a página de conclusão no final (completedHtml)",
    showPageNumbers: "Mostrar número da página",
    questionErrorLocation: "Localização do erro da pergunta",
    showProgressBar: "Mostrar barra de progresso",
    mode: "Modo",
    goNextPageAutomatic: "Ao responder todas as perguntas, ir automaticamente para a próxima página",
    checkErrorsMode: "Modo de verificação de erros",
    clearInvisibleValues: "Limpar valores invisíveis",
    startSurveyText: "Texto para botão de começar",
    pagePrevText: "Texto para botão de página anterior",
    pageNextText: "Texto para botão de página seguinte",
    completeText: "Texto para botão de completar",
    requiredText: "Símbolo(s) para perguntas obrigatórias",
    questionStartIndex: "Index das perguntas (1, 2 or 'A', 'a')",
    questionTitleTemplate: "Template do título da pergunta, default é: '{no}. {obrigatório} {título}'",
    firstPageIsStarted: "Primeira página do questionário é a página de início.",
    isSinglePage: "Mostrar todos elementos em uma página",
    maxTimeToFinishPage: "Tempo máximo para finalizar página do questionário",
    showTimerPanel: "Mostrar o painel de cronómetro",
    showTimerPanelMode: "Mostrar painel de modo de cronómetro",

    defaultPanelValue: "valor por defeito do painel",
    defaultRowValue: "valor por defeito da linha",
    hasNone: "não tem nenhum",
    noneText: "nenhum texto",

    text: "texto",
  }
};

editorLocalization.locales["pt"] = portugueseTranslation;
